import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { UpdateUserData } from './my-account.models';
import { HttpService } from '@app/core/services/http/http.service';
import { endpoints } from '@app/constants';
import { Globals } from '@app/shared/models';

@Injectable({
  providedIn: 'root'
})
export class ProfileService {

  constructor(
    private http: HttpService,
    public globals: Globals
  ) { }
  updateProfile = (data: UpdateUserData): Observable<object> => {
    return this.http
      .put({ url: `${endpoints.profile}`, body: data })
      .pipe(
        mergeMap(this.handleUpdateProfile),
        catchError((error) => of(error)),
      );
  }
  private handleUpdateProfile(response: any): Observable<object> {
    const { ExceptionType: exceptionType, Message: message } = response;
    if (exceptionType) {
      throw Error(message);
    }

    return of(response);
  }

}